import * as React from "react";

const BadgeIcon = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="24"
    height="24"
    fill="none"
    viewBox="0 0 24 24"
  >
    <path
      fill="#000"
      d="M18.306 2.063h-3.459V.706A.706.706 0 0 0 14.141 0H9.86a.706.706 0 0 0-.706.706v1.357H5.694A2.12 2.12 0 0 0 3.577 4.18v17.702A2.12 2.12 0 0 0 5.694 24h12.612a2.12 2.12 0 0 0 2.118-2.118V4.18a2.12 2.12 0 0 0-2.118-2.117m-7.741-.651h2.87v2.612c0 .79-.643 1.435-1.435 1.435a1.437 1.437 0 0 1-1.435-1.435zm8.447 20.47c0 .39-.317.706-.706.706H5.694a.707.707 0 0 1-.706-.706V4.18c0-.389.317-.706.706-.706h3.46v.55A2.85 2.85 0 0 0 12 6.87a2.85 2.85 0 0 0 2.847-2.847v-.55h3.46c.388 0 .705.317.705.706z"
    ></path>
    <path
      fill="#000"
      d="M9.096 17.75h5.808c.39 0 .706-.317.706-.707v-1.849a2.94 2.94 0 0 0-1.54-2.583c.305-.421.486-.939.486-1.498A2.56 2.56 0 0 0 12 8.557a2.56 2.56 0 0 0-2.556 2.556c0 .56.181 1.077.487 1.498a2.94 2.94 0 0 0-1.541 2.583v1.85c0 .389.316.705.706.705M12 9.968c.631 0 1.144.513 1.144 1.144s-.513 1.144-1.144 1.144-1.144-.513-1.144-1.144.513-1.144 1.144-1.144m-2.198 5.225c0-.84.684-1.525 1.525-1.525h1.346c.841 0 1.525.684 1.525 1.525v1.143H9.802zm5.622 4.241H8.576a.706.706 0 0 0 0 1.412h6.848a.706.706 0 1 0 0-1.412"
    ></path>
  </svg>
);

export default BadgeIcon;
